import React from 'react';

import { makeMuiStyles, useCommonStyles } from '@styles';

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    padding: '2rem 2rem',
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.down('sm')]: {
      padding: '2rem 1rem',
    },
  },
  inner: {
    ...common.flexColumn,
    maxWidth: '70rem',
    padding: '1rem',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
}));

export const CargoTrackingContainer: React.FC<React.PropsWithChildren<{}>> = (props) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const { children } = props;

  return (
    <div className={classes.container}>
      <div className={classes.inner}>{children}</div>
    </div>
  );
};
